import { Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { LeaveYourCommentTitle } from "../../../../../Constants/Constants";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Btn } from "../../../../../AbstractElements";

const LeaveYourComment = () => {
  return (
    <Col sm="12">
      <Card className="blog-contact">
        <CommonCardHeader title={LeaveYourCommentTitle} headClass="pb-0 border-0" />
        <CardBody>
          <Form className="default-form">
            <Row>
              <Col md="4" sm="4">
                <FormGroup>
                  <Label>Name</Label>
                  <Input type="text" placeholder="Enter your name" required />
                </FormGroup>
              </Col>
              <Col md="4" sm="4">
                <FormGroup>
                  <Label>Email</Label>
                  <Input type="email" placeholder="Enter your email" required />
                </FormGroup>
              </Col>
              <Col md="4" sm="4">
                <FormGroup>
                  <Label>Website</Label>
                  <Input type="text" placeholder="Enter your website" required />
                </FormGroup>
              </Col>
              <Col xs="12">
                <FormGroup>
                  <Label>Comment</Label>
                  <Input type="textarea" placeholder="Write your comment" rows={6}/>
                </FormGroup>
                <Btn color="primary">Post Comment</Btn>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LeaveYourComment;
